import { useParams } from 'react-router-dom';
import SEOHead from '@/components/base/SEOHead';
import Breadcrumb from '@/components/base/Breadcrumb';
import ArticleCard from '@/components/feature/ArticleCard';
import { categories } from '@/mocks/categories';
import { getArticlesByCategory } from '@/mocks/articles';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);
  const articles = slug ? getArticlesByCategory(slug) : [];

  if (!category) {
    return (
      <div className="min-h-screen flex items-center justify-center pt-16">
        <div className="text-center">
          <h1 className="font-heading text-2xl font-bold text-foreground-900 mb-3">分类未找到</h1>
          <p className="text-foreground-600">请检查链接是否正确</p>
        </div>
      </div>
    );
  }

  const categorySchema = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: `${category.name} - 六合彩指南`,
    description: category.description,
    url: `https://liuhecai-zhinan.example.com/category/${category.slug}`,
    isPartOf: {
      '@type': 'WebSite',
      name: '六合彩指南',
      url: 'https://liuhecai-zhinan.example.com',
    },
  };

  return (
    <>
      <SEOHead
        title={`${category.name} - 六合彩指南 | 精选${category.name}文章`}
        description={category.description}
        keywords={`六合彩${category.name},六合彩网站,${category.name}指南,六合彩资讯`}
        canonicalUrl={`https://liuhecai-zhinan.example.com/category/${category.slug}`}
        schema={categorySchema}
      />
      <main className="pt-20 pb-10 md:pb-14">
        <div className="max-w-[1280px] mx-auto px-4 md:px-6">
          <Breadcrumb
            items={[
              { label: '首页', href: '/' },
              { label: category.name },
            ]}
          />

          <div className="mt-6 mb-8">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600">
                <i className={`${category.icon} text-xl`}></i>
              </div>
              <div>
                <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
                  {category.name}
                </h1>
                <p className="text-sm text-foreground-500 mt-0.5">
                  共 {category.articleCount} 篇文章
                </p>
              </div>
            </div>
            <p className="text-foreground-600 text-sm md:text-base">{category.description}</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {articles.map((article) => (
              <ArticleCard key={article.slug} {...article} />
            ))}
          </div>

          {articles.length === 0 && (
            <div className="text-center py-16">
              <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-background-100">
                <i className="ri-inbox-line text-2xl text-foreground-400"></i>
              </div>
              <p className="text-foreground-600">该分类暂无文章</p>
            </div>
          )}
        </div>
      </main>
    </>
  );
}